import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useRef } from "react";
import { useCallback } from "react";
import { useState } from "react";

export default props =>{
    useStyles(cls);
    const [number, setNumber] = useState(0);
    const initRef = useRef(true);

    const handleRef = useCallback((element) =>{
        initRef.current = false;
        if(element?.offsetHeight){
            setNumber(element.offsetHeight);
        }
    }, []);

    return <React.Fragment> 
        {
            (initRef.current || number > 0) && <div className={cls.OrderFixedFooter}>
                <div className={cls.Container}>
                    <div ref={handleRef}>
                        {props?.children}
                    </div>
                    
                </div>
            </div>
        }

        {
            number > 0 && <div style={{height: `${number+38}px`}}></div>
        }
    </React.Fragment>
}